// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { firestore, database } from 'firebase'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import { firestoreAction, firebaseAction } from 'vuexfire'
import { db, rdb } from '../../firebase/init'
import { RdbUserType } from '../../types'

import store from '..'

// const serializeId = (snapshot: database.DataSnapshot) => {
//   console.log('here snapshot is: ', snapshot)
//   const data:any = snapshot.val()
//   console.log('here data is: ', data)
//   data.id = snapshot.key
//   console.log('here data2 is: ', data)
//   return data
// }

@Module({ name: 'appStore', store, dynamic: true })
export default class AppStore extends VuexModule {
  activeTab = ''

  dbUsers:RdbUserType[] = []

  updateAvailable = false

  @Mutation
  setTab(tab: string) {
    this.activeTab = tab
  }

  @Action
  setViewTime() {
    console.log('setting: ', this.userRef)
    if (this.userRef) this.userRef.child('lastNotification').set(new Date().getTime())
  }

  get online() {
    return navigator.onLine
  }

  get onlineUsers() {
    console.log('here online users: ', this.dbUsers)
    return this.dbUsers.filter(user => user.online)
  }

  get userDbInfo() {
    console.log('here 2323', this.dbUsers)
    if (this.dbUsers) {
      console.log('here 2323', this.dbUsers)
      return this.dbUsers.find(user => user['.key'] === store.getters.uid) || {}
    } return {}
  }

  @Mutation
  updateIsAvailable(x:boolean) {
    this.updateAvailable = x
  }

  @Action
  appBind() {
    console.log('binding apps fromn ', store.getters.location)
    const onlineUsersAction = firebaseAction(({ bindFirebaseRef }) => bindFirebaseRef('dbUsers', rdb.ref(`locations/${store.getters.location}/users`))) as Function
    return onlineUsersAction(this.context)
  }

  @Action
  setShift(shift:string|boolean) {
    console.log('setting shift: ', shift)
    if (this.userRef) this.userRef.child('online').set(shift)
  }

  get userRef() {
    if (!store.getters.location || !store.getters.uid) return null
    return rdb.ref(`locations/${store.getters.location}/users/${store.getters.uid}`)
  }

  @Action
  async removeOfflineRef() {
    if (this.userRef) {
      this.userRef.off()
      await this.userRef.update({ online: false, lastOnlineChanged: database.ServerValue.TIMESTAMP })
      return true
    } return true
  }

  @Action
  setOnlineStatus() {
    rdb.ref('.info/connected').on('value', (snapshot) => {
    // If we're not currently connected, don't do anything.
      if (snapshot.val() === false) {
        return;
      }
      console.log('in setOnlineStatus', this.userRef)
      if (this.userRef) {
        this.userRef.onDisconnect().update({ online: false, lastOnlineChanged: database.ServerValue.TIMESTAMP }).then(() => {
        // The promise returned from .onDisconnect().set() will
        // resolve as soon as the server acknowledges the onDisconnect()
        // request, NOT once we've actually disconnected:
        // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

          // We can now safely set ourselves as 'online' knowing that the
          // server will mark us as offline once we lose connection.

          if (this.userRef) {
            console.log('here setting online')
            this.userRef.update({ online: true, lastOnlineChanged: database.ServerValue.TIMESTAMP })
              .then(x => console.log('resultset is: ', x))
          }
        })
      }
    })
  }
}

// ,
